import { render, staticRenderFns } from "./CRMToggleCard.vue?vue&type=template&id=3f789353&scoped=true"
import script from "./CRMToggleCard.vue?vue&type=script&lang=ts"
export * from "./CRMToggleCard.vue?vue&type=script&lang=ts"
import style0 from "./CRMToggleCard.vue?vue&type=style&index=0&id=3f789353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f789353",
  null
  
)

export default component.exports